import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessTrassetsExportStatus: 'idle',
    startProcessTrassetsExportError: undefined as any,
    loadUserParamsProcessTrassetsExportStatus: 'idle',
    loadUserParamsProcessTrassetsExportError: undefined as any,

    processTrassetsExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessTrassetsExport = createAsyncThunk('processTrassetsExportSlice/startProcessTrassetsExport', async ({ processTrassetsExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessTrassetsExport/`,
        prepareData(processTrassetsExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessTrassetsExportStatus } = getState().processTrassetsExportSlice
        return startProcessTrassetsExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessTrassetsExport = createAsyncThunk('processTrassetsExportSlice/loadUserParamsProcessTrassetsExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessTrassetsExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessTrassetsExportStatus } = getState().processTrassetsExportSlice
        return loadUserParamsProcessTrassetsExportStatus !== 'pending'
    }
})

const ProcessTrassetsExportSlice = createSlice({
    name: 'processTrassetsExportSlice',
    initialState,
    reducers: {
        resetstartProcessTrassetsExport: (state) => {
            state.job = undefined
            state.startProcessTrassetsExportError = undefined
        },
        resetstartProcessTrassetsExportError: (state) => {
            state.startProcessTrassetsExportError = undefined
        },
        resetloadUserParamsProcessTrassetsExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessTrassetsExportError = undefined
        },
        resetloadUserParamsProcessTrassetsExportError: (state) => {
            state.loadUserParamsProcessTrassetsExportError = undefined
        },
        removeFromProcessTrassetsExportListById: (state, action) => {
            state.processTrassetsExportList = state.processTrassetsExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessTrassetsExportListByIds: (state, action) => {
            state.processTrassetsExportList = state.processTrassetsExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processTrassetsExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessTrassetsExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processTrassetsExportList = []
            state.startProcessTrassetsExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessTrassetsExport.pending, (state) => {
            state.startProcessTrassetsExportStatus = 'pending'
            state.startProcessTrassetsExportError = undefined
        })
        builder.addCase(startProcessTrassetsExport.fulfilled, (state, action) => {
            state.startProcessTrassetsExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessTrassetsExport.rejected, (state, action) => {
            state.startProcessTrassetsExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessTrassetsExportError = action.error.message
            } else {
                state.startProcessTrassetsExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessTrassetsExport.pending, (state) => {
            state.loadUserParamsProcessTrassetsExportStatus = 'pending'
            state.loadUserParamsProcessTrassetsExportError = undefined
        })
        builder.addCase(loadUserParamsProcessTrassetsExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessTrassetsExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessTrassetsExport.rejected, (state, action) => {
            state.loadUserParamsProcessTrassetsExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessTrassetsExportError = action.error.message
            } else {
                state.loadUserParamsProcessTrassetsExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessTrassetsExport,
    resetstartProcessTrassetsExportError,
    resetloadUserParamsProcessTrassetsExport,
    resetloadUserParamsProcessTrassetsExportError,
    removeFromProcessTrassetsExportListById,
    removeFromProcessTrassetsExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessTrassetsExportSlice.actions
export default ProcessTrassetsExportSlice.reducer
